import React from 'react'

const Terms = (props) => {
  return (
    <div className="container-fluid">
      <div className="row mt-4">
        <div className="col-10 mx-auto bg-white p-4" style={{ borderRadius: 4, marginBottom: 100 }}>
          <h2 className="text-darkGreen ">Konkurrencebetingelser</h2>

          <h5 className="text-darkGreen mt-4 mb-0">Kickstart: Weekendkonkurrence</h5>
          <p>
            Få en drømmestart i Varelotteriets forhandlerkonkurrence ved at sælge en masse nye lodder i løbet af
            weekenden fra fredag d. 19. til søndag den 21. september kl. 23:59. Den forhandler, der sælger flest nye
            lodder, vinder et Supergavekort på 500 kr. Ved pointsammenfald er det den forhandler, der først har fået
            solgt flest nye lodder, som kåres til vinder. Vinderen findes mandag den 22. september.
          </p>

          <h5 className="text-darkGreen mt-4 mb-0">Ugens højdespringer</h5>
          <p>
            Ugens højdespringer kører hver uge fra mandag til søndag indtil kl. 23.59. Vinderen er den forhandler, der
            har solgt flest nye lodder. Ved pointsammenfald er det den forhandler, der først har fået solgt flest nye
            lodder, som kåres til vinder. Præmien er 500 kr. Der tildeles derudover også en andenpræmie på 300 kr. til
            forhandleren med næstflest solgte lodder. Vinderne udtrækkes hver mandag.
            <br />
            <br />
            Datoer for udtrækning af vindere er følgende: 29/9, 6/10, 13/10, 20/10, 27/10, 3/11, 10/11, 17/11, 24/11,
            1/12, 8/12 og 15/12. Der udloddes i alt 12 Supergavekort til 500 kr. til vinderne samt 12 Supergavekort til
            300 kr. til andenpladserne.
          </p>

          <h5 className="text-darkGreen mt-4 mb-0">5 på stribe</h5>
          <p>
            Sælg minimum ét nyt lod 5 dage i træk. Under ’Min side’ kan du se, hvor mange dage du har solgt lodder i
            træk. Konkurrencen kører fra tirsdag til lørdag, og vinderen kåres ved lodtrækning hver mandag.
            <br />
            <br />
            Datoer for udtrækning af vinderne er følgende: 29/9, 6/10, 13/10, 20/10, 27/10, 3/11, 10/11, 17/11, 24/11,
            1/12, 8/12 og 15/12. Der udloddes i alt 12 Supergavekort til 600.
          </p>

          <h5 className="text-darkGreen mt-4 mb-0">Speedy Gonzales</h5>
          <p>
            Skynd dit at sælge et nyt lod hver lørdag mellem kl. 12.00 – 12:10. Vinderen kåres ved lodtrækning hver
            mandag. Præmien er et Supergavekort er på 500 kr.
            <br />
            <br />
            Datoer for udtrækning af vindere er følgende: 29/9, 6/10, 13/10, 20/10, 27/10, 3/11, 10/11, 17/11, 24/11,
            1/12, 8/12 og 15/12. Der udloddes i alt 12 supergavekort til 500 kr.
          </p>

          <h5 className="text-darkGreen mt-4 mb-0">Danmarks bedste forhandlere</h5>
          <p>
            Sælg flest nye lodder i konkurrenceperioden (fra d. 19. september – 18. december) og kom på top-10-listen
            over Danmarks bedste forhandlere. Vinderne bliver udtrukket den 19. december, og præmierne er som følger:
            <ol>
              <li>Plads: Supergavekort på 3.000 kr.</li>
              <li>Plads: Supergavekort på 1.500 kr.</li>
              <li>Plads: Supergavekort på 1.200 kr.</li>
              <li>Plads: Supergavekort på 1.000 kr.</li>
              <li>Plads: Supergavekort på 700 kr.</li>
              <li>Plads: Supergavekort på 600 kr.</li>
              <li>Plads: Supergavekort på 500 kr.</li>
              <li>Plads: Supergavekort på 500 kr.</li>
              <li>Plads: Supergavekort på 500 kr.</li>
              <li>Plads: Supergavekort på 500 kr.</li>
            </ol>
          </p>

          <h5 className="text-darkGreen mt-4 mb-0">Min side</h5>
          <p>
            Et hurtigt overblik over din placering i den samlede stilling. På denne side får du også oplysninger om,
            hvor mange lodder du mangler at sælge for at rykke en placering op. Du kan også se hvor mange dage i træk,
            du har solgt minimum ét nyt lod
          </p>
        </div>
      </div>
    </div>
  )
}
export default Terms
